export interface VyFormErrorProps {
  message?: string;
}

export const VyFormError = (props: VyFormErrorProps) => {
  const { message } = props;

  if (!message) return null;

  return <p className="text-xs text-red-500">{message}</p>;
};
